<template>
<div class="chapter">
<div class="inner_page">
<h2 id="OtherBooks" title="Other Books"></h2>
<p class="otherbooksheader">Books by Charles G. Irion and Ronald J. Watkins</p>
<p class="otherbookssubheader">The Summit Murder Mystery Series</p>
<p class="otherbooks">Murder on Everest</p>
<p class="otherbooks">Abandoned on Everest (a prequel to Murder on Everest)</p>
<p class="otherbooks">Murder on Elbrus</p>
<p class="otherbooks">Murder on Mt. McKinley</p>
<p class="otherbooks">Murder on Puncak Jaya (Summer 2011)</p>
<p class="otherbooks">Murder on Aconcagua (Winter 2012)</p>
<p class="otherbooks">Murder on Vinson Massif (Summer 2012)</p>
<p class="otherbooks">Murder on Kilimanjaro (Winter 2013)</p>
<p class="otherbooksheader">Books by Charles G. Irion</p>
<p class="otherbooks">Remodeling Hell</p>
<p class="otherbooks">Autograph Hell</p>
<p class="otherbooks">Car Dealer Hell</p>
<p class="otherbooks">Divorce Hell</p>
<p class="otherbooks">Roadkill Cooking for Campers (Wild Game Cookbook)</p>
<p class="otherbooksheader">Books by Ronald J. Watkins</p>
<p class="otherbooks">Unknown Seas</p>
<p class="otherbooks">Birthright</p>
<p class="otherbooks">Cimmerian</p>
<p class="otherbooks">Evil Intentions</p>
<p class="otherbooks">Against Her Will</p>
<p class="otherbooks">A Suspicion of Guilt</p>
<p class="otherbooks">A Deadly Glitter</p>
<p class="otherbooks">Alter Ego</p>
<p class="otherbooks">Shadows and Lies</p>
<p class="otherbooks">High Crimes and Misdemeanors</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OtherBooks.vue?453b6149